export const FontFamily = {
  regular: '"OpenSansHebrew-Regular", sans-serif',
  bold: '"OpenSansHebrew-Bold", sans-serif',
  extraBold: '"OpenSansHebrew-ExtraBold", sans-serif',
};

